import style from "./Accordion.module.css"
import {useState} from "react";
import * as icons from '../../svg/svg';
import MediaQueryUtils from "../../utils/MediaQueryUtils";

function Accordion(props) {

    const [buttonAccordion,setButtonAccordion] = useState({tipo:"plus",icona:icons.plusIcon})
    let isPageWide = MediaQueryUtils('(min-width: 1270px)')
    // Stato reale del pannello: l'icona "plus" indica pannello chiuso (azione: espandi),
    // l'icona "minus" pannello aperto (azione: comprimi).
    const aperto = buttonAccordion.tipo === "minus"

    function openCloseAccordion(){
        if(buttonAccordion.tipo === "plus"){
            let newButtonAccordion = {tipo:"minus",icona:icons.minusIncon}
            setButtonAccordion(newButtonAccordion)
        }else{
            let newButtonAccordion = {tipo:"plus",icona:icons.plusIcon}
            setButtonAccordion(newButtonAccordion)
        }
    }

    return (
        <div id={props.id}>
            <div className="card">
                <div className={"card-header ".concat(style.accordionCustom)} id={"heading".concat(props.id)}>
                    <div className="row">
                        <div className={isPageWide?"col-11":"col-10"} style={{display: "flex", alignItems: "center"}}>
                           <span className={style.accordionCustomSpan} style={{textAlign:"left"}}>
                            {props.headerText}
                        </span>
                        </div>
                        <div className={"col-1"}>
                            {/* Il bottone contiene solo l'icona SVG: senza aria-label sarebbe
                                privo di nome accessibile (WCAG 4.1.2). L'etichetta e' costruita
                                sul titolo dell'accordion e riflette l'azione disponibile.
                                aria-expanded era cablato a "true": ora deriva dallo stato reale
                                (icona "minus" = pannello aperto, "plus" = pannello chiuso). */}
                            <button type="button" className={style.buttonAccordionCustom} data-toggle="collapse" data-target={"#collapse".concat(props.id)}
                                    aria-label={(aperto ? "Comprimi " : "Espandi ").concat(props.headerText ? props.headerText : "il pannello")}
                                    aria-expanded={aperto} aria-controls={"collapse".concat(props.id)} onClick={openCloseAccordion}>
                                {buttonAccordion.icona}
                            </button>
                        </div>
                    </div>
                </div>

                <div id={"collapse".concat(props.id)} className={"collapse ".concat(style.accordionCustom)} aria-labelledby={"heading".concat(props.id)} data-parent={"#".concat(props.id)}>
                    <div className="card-body">
                        {props.accordionBody}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Accordion